import React, {Component} from 'react';
import {  Link } from 'react-router-dom'; 
  
import { base_url} from '../common/Constants';
 


 
class PageHeader extends React.Component{
 
    render()
    { 

        const banners = JSON.parse(localStorage.getItem("page_banners"));
        var banner = base_url+'assets/images/banner/about-banner.jpg';
        

        if(this.props.banner)
        {
            banner = banners[this.props.banner].image ;
        }
         
        return (  <div class="wt-bnr-inr overlay-wraper" style={{backgroundImage:'url('+banner+')'}}>
            	<div class="overlay-main bg-black opacity-05"></div>
                <div class="container">
                    <div class="wt-bnr-inr-entry">
                        <h1 class="text-white">{this.props.title}</h1>
                    </div>
                </div>
            </div> 
        );
     
}

}

export default PageHeader;